import { Navigate } from "react-router-dom";
import useCapabilities from "@/hooks/useCapabilities";
import { getGrpHomePath } from "./_utils";

export default function GrpIndex() {
  const { loaded, capabilities } = useCapabilities();

  if (!loaded) return null;

  return <Navigate to={getGrpHomePath(capabilities)} replace />;
}
